import { useTranslation } from 'react-i18next';
import { Rocket } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';

export function GettingStartedSection() {
  const { t } = useTranslation('help');
  const s = 'sections.gettingStarted';

  return (
    <GuideSection
      id="getting-started"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={Rocket}
    >
      <GuideSubSection title={t(`${s}.login.title`)}>
        <p>{t(`${s}.login.p1`)}</p>
        <p>{t(`${s}.login.p2`)}</p>
        <p>{t(`${s}.login.p3`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.twoFactor.title`)}>
        <p>{t(`${s}.twoFactor.p1`)}</p>
        <p>{t(`${s}.twoFactor.p2`)}</p>
        <p>{t(`${s}.twoFactor.trustedDevice`)}</p>
        <p>{t(`${s}.twoFactor.p3`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.navigation.title`)}>
        <p>{t(`${s}.navigation.p1`)}</p>
        {/* No hardcoded labels here — each string names its own subject, so this stays translated. */}
        <ul className="list-disc list-inside space-y-1.5 ml-1">
          <li>{t(`${s}.navigation.sidebar`)}</li>
          <li>{t(`${s}.navigation.topbar`)}</li>
          <li>{t(`${s}.navigation.breadcrumbs`)}</li>
        </ul>
      </GuideSubSection>
    </GuideSection>
  );
}
